import * as React from "react"
import { Link } from 'react-router-dom'
import styled from "styled-components"
import Layout from '../../components/Layout'

type PostRecord = Record<string, MarkdownModule>;

// 1. Define the module type based on vite-plugin-markdown exports
interface MarkdownModule {
  attributes: {
    title: string;
    date: string;
    [key: string]: any;
  };
  // We don't need the component itself for the index page, just the metadata
}

// 2. Use eager glob to load all metadata at build time
const postFiles = import.meta.glob<MarkdownModule>('/src/blog/*.md', { eager: true });

const Links = styled.ul`
  max-width: 800px;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  padding: 0;
  li { margin-bottom: 1.5rem; }
  .date { font-size: 0.9rem; color: var(--color-secondary); margin-bottom: 0.25rem; }
  h3 { margin-top: 0; margin-bottom: 0.5rem; }
`

const nonMDPosts: [string, MarkdownModule][] = [
  [
    '/src/blog/hurricanes-and-decisions.md',
    {
      attributes: {
        title: 'Hurricanes and Decisions', // Added required title
        date: '2023-09-15'
      }
    }
  ]
];

const BlogIndexPage: React.FC = () => {
  console.log([...Object.entries(postFiles), ...nonMDPosts]);
  // 3. Transform the glob object into a sorted array of posts
  const posts = [...Object.entries(postFiles), ...nonMDPosts]
    .map(([path, module]) => {
      // Extract the filename from the path to use as the slug
      // e.g., "/src/blog/hello-world.md" -> "hello-world"
      const slug = path.split('/').pop()?.replace('.md', '') || '';
      
      return {
        slug,
        frontmatter: module.attributes,
      };
    })
    // Sort by date (descending)
    .sort((a, b) => 
      new Date(b.frontmatter.date).getTime() - new Date(a.frontmatter.date).getTime()
    );

  return (
    <Layout pageTitle="Fabio de Sousa - Blog">
      <Links>
        {posts.map(post => (
          <li key={post.slug}>
            <div className="date">{post.frontmatter.date}</div>
            <h3>
              <Link to={`/blog/${post.slug}`}>
                {post.frontmatter.title}
              </Link>
            </h3>
          </li>
        ))}
      </Links>
    </Layout>
  )
}

export default BlogIndexPage
